import { dispatchSetNavNode } from 'containers/Header/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getRegion } from 'utils/Region';

export const usePrivateRoute = () => {
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const { model } = useSelector(state => state.navigation);
  const qatarConfig = useSelector(state =>
    JSON.parse(state.metadata?.qatar2022_enabled || '{}'),
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const enableQatarByUserType =
      qatarConfig?.default?.enable[user.userType.toLowerCase()];

    if (enableQatarByUserType) return;
    navigate(`/${getRegion()}/homeuser`, { replace: true });
    const homeuserNode = model?.find(node => node.code === 'homeuser');
    dispatch(dispatchSetNavNode(homeuserNode));
  }, []);
};
